<template>
  <div class="actModules" v-show="validate">
    <div class="close" @click="close()">关闭</div>
    <div class="rules">
      <p v-html="modulesRules"></p>
      <a
        :href="link"
        class="button"
      >查看详情</a>
    </div>
  </div>
</template>

<script>
import bus from '../../../bus';
export default {
	name: 'h5-popup',
	actConfig: {
		labels: {
			link: '跳转链接',
			modulesRules: '规则描述'
		}
	},
	props: {
		link: {
			type: String,
			default: ''
		},
		modulesRules: {
			type: String,
			default: '规则文案'
		}
	},
	data () {
		return {
			validate: false
		};
	},
	mounted () {
		bus.$on('showNamelist', () => {
			this.validate = window.validate;
		});
	},
	methods: {
		close () {
			this.validate = false;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/localCom/x-popup.vue